import HistoryPage from './history-page';

export default HistoryPage;